import {
    IntraDayProfileConfiguration,
    initialIntraDayProfileConfiguration,
} from './configuration/IntraDayProfileConfiguration';
import {
    initialIntraDayProfileStreamState,
    IntraDayProfileDataState,
} from './data/IntraDayProfileStreamDataState';

import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';
import {
    initialIntraDayProfileComponentState,
    IntradayProfilesComponentState,
} from 'widgets/intraDayProfile/store/intradayProfilesComponentSlice';

export type IntraDayProfileWidgetState =
    StreamingWidgetState<IntraDayProfileDataState> &
        WidgetWithConfigState<IntraDayProfileConfiguration> &
        WidgetWithComponentState<IntradayProfilesComponentState>;

export interface IntraDayProfileWidgetsState {
    [widgetId: string]: IntraDayProfileWidgetState;
}

export const initialIntraDayProfileWidgetState: IntraDayProfileWidgetState = {
    config: initialIntraDayProfileConfiguration,
    component: initialIntraDayProfileComponentState,
    stream: initialIntraDayProfileStreamState,
};

export const initialIntraDayProfileWidgetsState: IntraDayProfileWidgetsState =
    {};
